module.exports = __webpack_public_path__ + "static/media/precision.ab10a378.png";